
import { getPosition } from './Html5-wrapper';

import { uniqueMountScript } from '../utils';

import ExternalConfiguration from '../../external-configuration';

export async function getPureGoogleMapsLocation() {
  const position = await getPosition();
  await uniqueMountScript( 'maps-google-apis-script', `//maps.googleapis.com/maps/api/js?key=${ExternalConfiguration.Credentials.GoogleMapsApiKey}`);
  const geocoder = new window.google.maps.Geocoder();
  const latlng = new window.google.maps.LatLng( position.coords.latitude, position.coords.longitude);
  return new Promise( (resolve, reject) => {
    geocoder.geocode( {'latLng': latlng}, (results, status) => {
      if( status === window.google.maps.GeocoderStatus.OK) {
        let country, aal_1, aal_2, city, street;  // TODO implementar un geobloqueo que use todas estas opciones
        results.forEach( address => {
          address.address_components.forEach( address_component => {
            if( address_component.types.indexOf( 'country') > -1) {
              country = address_component.short_name;
            }
            if( address_component.types.indexOf( 'administrative_area_level_1') > -1) {
              aal_1 = address_component.short_name;   // REVIEW NOTE !!!!! NO ES EL CODIGO https://es.wikipedia.org/wiki/ISO_3166-2:ES#cite_note-cooficial-3
            }
            if( address_component.types.indexOf( 'administrative_area_level_2') > -1) {
              aal_2 = address_component.short_name;
            }
            if( address_component.types.indexOf( 'locality') > -1) {
              city = address_component.short_name;
            }
            if( address_component.types.indexOf( 'route') > -1) {
              street = address_component.short_name;
            }
          });
        });
        resolve({ latitude: position.coords.latitude , longitude: position.coords.longitude , country, aal_1, aal_2, city, street, results});
      } else {
        reject({ message: 'Error, imposible conectar con la API de google maps para geolocalizar las coordenadas.' });
      }
    });
  });
}

export async function uniqueGetPureGoogleMapsLocation() {
  if( uniqueGetPureGoogleMapsLocation.cached) return uniqueGetPureGoogleMapsLocation.cached;
  else return uniqueGetPureGoogleMapsLocation.cached = await getPureGoogleMapsLocation();
}

export async function getLocation() {
  const pureLocation = await uniqueGetPureGoogleMapsLocation();
  const country = pureLocation.country;
  const subdivision_0 = `${country}-${pureLocation.aal_1}`;   // REVIEW NOTE !!!!! NO ES EL CODIGO https://es.wikipedia.org/wiki/ISO_3166-2:ES#cite_note-cooficial-3
  const subdivision_1 = `${country}-${pureLocation.aal_2}`;   // Provincia

  return { country, subdivision_0, subdivision_1, pureLocation };
}

export async function isLocationInList( locationsList) {
  const location = await getLocation();
  return locationsList.indexOf( location.country) > -1 ||
    locationsList.indexOf( location.subdivision_0) > -1 ||
    locationsList.indexOf( location.subdivision_1) > -1;
}
